// deep clone state
import { cloneDeep } from 'lodash';

export function cloneState(state) {
  return cloneDeep(state);
}
